export class ServerResponse{
    public static readonly OTP_SENT:string = "OTPWasSent";
    public static readonly USER_IS_BLOCKED:string = "UserIsBlocked";
    public static readonly SHOW_DECLERATION:boolean = true;
    public static readonly ALREADY_EXIST:string = "RequestAlreadyExists";
    public static readonly NEED_DETAILS:string = "NeedDetails";
    public static readonly REQUEST_CEATED:string = "NewRequestCreated";
    public static readonly ISSUE_DATE:string = "MustEnterIdIssueDate";
    public static readonly CREDIT_CARD:string = "MustEnterCreditCard";
    public static readonly VALIDATE_DETAILS:string = "MustValidateDetails";
    public static readonly IDENTIFICATION_TYPE:string = "MustSelectStrictIdentificationType";
    public static readonly FULL_STRICT:string = "FullStrictIsNeeded";
    public static readonly CHOICE_STRICT:string = "ChoiceStrictIsNeeded";
    public static readonly CHANGE_PASSWORD:string = "MustChangePassword";
    public static readonly PERMANENT_PASSWORD:string = "MustEnterPassword";
    public static readonly PASSWORD_USER_LOCKED:string = "PasswordUserLocked";
    public static readonly REGISTRATION_SUCCESS:string = "RegistrationSuccess";
    public static readonly USER_LOGGED_IN_SUCCESS:string = "UserLoggedIn";
    public static readonly HAS_OPEN_CALLS:boolean = true;
    public static readonly HAS_NOT_OPEN_CALLS:boolean = false;
    public static readonly REDIRECT:boolean = true;
}
